import React from 'react';
import {CheckCircleIcon} from '@heroicons/react/20/solid'

type TStepNavigationProps = {
    steps: Array<String>,
    currentStep: Number
}

const StepNavigation = ({ steps, currentStep }: TStepNavigationProps) => {
    return (
        <div>
            <div className={'text-center text-gray-400'} id={"projectSteps"}>
                Step
            </div>

            <div className="flex items-center justify-center py-4 mb-4 gap-x-10 cursor-not-allowed">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`flex items-center justify-center w-12 h-12 rounded  ${
                            index === currentStep
                                ? 'bg-primary text-white'
                                : index < currentStep
                                    ? 'bg-gray-200'
                                    : 'bg-gray-50'
                        }`}
                    >
                        {index < currentStep ? <CheckCircleIcon className="text-secondary h-8" /> : index + 1}
                    </div>
                ))}
            </div>
        </div>

    );
};

export default StepNavigation;
